import React from "react";
import { connect } from "react-redux";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import LovdGeneType from "../../../../components/componentTypes/LovdGeneType";
import HelperText from "../../../../components/atoms/HelperText";

const LovdGene = ({ data }) => {
  if (!data || Object.keys(data || {}).length === 0) return null;

  return (
    <div className="varsome-result-fixed" data-testid="lovd-gene-component">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title={
            <>
              <a href={getVarsoUrl("https://www.lovd.nl/")} target="_blank">
                LOVD
              </a>
              <HelperText fieldDescriptionKey="LOVD" />
            </>
          }
          version={data?.version}
          content={
            <div className="varsome-inner-container">
              {(data?.number_of_individuals || data?.number_of_variants) && (
                <div className="tw-mb-4">
                  <table className="varsome-table varsome-table-fixed varsome-table-fixed--borderBody varsome-table-fixed--autoWidth tw-mx-6 tw-mb-6">
                    <thead>
                      <tr className="tw-border-t-0">
                        <th>Number of individuals</th>
                        <th>Number of variants</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{data?.number_of_individuals}</td>
                        <td>{data?.number_of_variants}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              {data?.phenotypes && data?.phenotypes.length > 0 && (
                <div className="tw-mb-4">
                  <table className="varsome-table varsome-table-fixed varsome-table-fixed--borderBody varsome-table-fixed--autoWidth tw-mx-6 tw-mb-6">
                    <thead>
                      <tr className="tw-border-t-0">
                        <th>Phenotype</th>
                        <th>Phenotype OMIM number</th>
                        <th>Inheritance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.phenotypes.map((phenotype, y) => (
                        <tr key={y}>
                          <td>{phenotype?.term}</td>
                          <td>
                            {phenotype?.source === "MIM" && (
                              <a
                                href={getVarsoUrl(
                                  `https://omim.org/entry/${phenotype?.accession}`
                                )}
                                target="_blank"
                              >
                                {phenotype?.accession}
                              </a>
                            )}
                          </td>
                          <td>
                            {phenotype?.inheritance_pattern && (
                              <>
                                {phenotype?.inheritance_pattern?.term &&
                                phenotype?.inheritance_pattern?.accession &&
                                phenotype?.inheritance_pattern?.source ===
                                  "HPO" ? (
                                  <a
                                    href={getVarsoUrl(
                                      `https://monarchinitiative.org/phenotype/HP:${phenotype?.inheritance_pattern?.accession}`
                                    )}
                                    target="_blank"
                                  >
                                    {phenotype?.inheritance_pattern?.term}
                                  </a>
                                ) : (
                                  `${
                                    phenotype?.inheritance_pattern?.term
                                      ? phenotype?.inheritance_pattern?.term
                                      : ""
                                  } ${
                                    phenotype?.inheritance_pattern?.accession
                                      ? phenotype?.inheritance_pattern
                                          ?.accession
                                      : ""
                                  } ${
                                    phenotype?.inheritance_pattern?.source
                                      ? phenotype?.inheritance_pattern?.source
                                      : ""
                                  }`
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          }
          titleDetailsRight={
            data?.lovd_link && (
              <div className="varsome-right">
                <small className="tw-mr-4">
                  <a
                    className="tw-ml-2 tw-text-2xs"
                    href={getVarsoUrl(data?.lovd_link)}
                    target="_blank"
                  >
                    View this on LOVD
                  </a>
                </small>
              </div>
            )
          }
        />
      </div>
    </div>
  );
};

LovdGene.propTypes = LovdGeneType;

LovdGene.defaultProps = {
  data: null,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(LovdGene);
